import React, { useMemo } from "react";
import right from "./../image/rightIcon.svg";

const SelectedNoteTempComp = ({ selectOptionObj, noteTypeKey = [] }) => {
   const titles = useMemo(() => {
      const newUniqueTitles = [];

      Object.entries(selectOptionObj).forEach(([key, option]) => {
         if (noteTypeKey.includes(key)) {
            option.title.forEach((title) => {
               if (!newUniqueTitles.includes(title)) {
                  newUniqueTitles.push(title);
               }
            });
         }
      });

      return newUniqueTitles;
   }, [noteTypeKey]);

   return (
      <div>
         <div className="vtwo-note-type-container">
            <div className="vtwo-note-type-box scrollbar-notes">
               {titles.map((title, index) => (
                  <>
                     <div className={`${index !== 0 && " border-bottom border"}`}></div>
                     <div key={index} className={`vtwo-note-type-list `}>
                        <img src={right} alt={right} className="" />
                        <div className="vtwo-temp-title-text">{title || "Clinical note"}</div>
                     </div>
                  </>
               ))}
            </div>
         </div>
         <div className="vtwo-terms-of-service">
            By tapping “Let’s Go” you agree to our
            <a href="https://app-user-data-pbh-dev.s3.amazonaws.com/privacy-policy+playback.pdf">“Terms of Service”</a>
            <div className="d-flex justify-content-center">
               <a href="https://app-user-data-pbh-dev.s3.amazonaws.com/Terms+%26+Conditions+playback.pdf">
                  privacy policy
               </a>
               .
            </div>
         </div>
      </div>
   );
};

export default SelectedNoteTempComp;
